export const loaderAction = (load) => async (dispatch, getState) => {
    dispatch(setLoader(load));
}

const setLoader = load => ({
    type: "LOADER",
    setLoader: load
});

